
import { Component, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import IconNoCC from '~/components/icons/IconNoCC.vue'
import IconTimer from '~/components/icons/IconTimer.vue'
import IconLock from '~/components/icons/IconLock.vue'
import IconHeadphones from '~/components/icons/IconHeadphones.vue'
import IconDelivery from '~/components/icons/IconDelivery.vue'
import { OfferTypeKey } from '~/core/offer.types'
import BestDealGuarantee from '~/components/widgets/BestDealGuarantee.vue'
import FeaturesBanner, { FeaturesBannerItem } from '~/components/sections/FeaturesBanner.vue'

@Component({
  components: {
    BestDealGuarantee,
    FeaturesBanner,
  },
})
export default class ComparatorLayout extends Vue {
  @PropSync('offerType', { required: true, default: '', type: String })
  private selectedOfferType!: OfferTypeKey

  @Prop({ required: false, default: () => [], type: Array })
  readonly devices!: any[]

  @PropSync('device', { required: false, default: () => ({}), type: Object })
  private selectedDevice!: Record<string, any>

  @Prop({ required: true, default: '', type: String })
  private readonly title!: string

  private featureBannersStyles = {
    '--features-icon-size': '32px',
    '--features-padding-y': '1.5rem',
  }

  get featuresBannerItems (): FeaturesBannerItem[] {
    return [
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-time.svg'),
        title: this.$t('compare.banner.other.1.title') as string,
        description: this.$t('compare.banner.other.1.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-crown.svg'),
        title: this.$t('compare.banner.other.2.title') as string,
        description: this.$t('compare.banner.other.2.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-lock.svg'),
        title: this.$t('compare.banner.other.3.title') as string,
        description: this.$t('compare.banner.other.3.description') as string,
      },
      {
        icon: require('~/assets/images/icons/features-banner/features-banner-icon-headphones.svg'),
        title: this.$t('compare.banner.other.4.title') as string,
        description: this.$t('compare.banner.other.4.description') as string,
      },
    ]
  }

  get credibilityItems () {
    return [{
      title: this.$t('credibility.title1'),
      content: this.$t('credibility.content1'),
      icon: IconNoCC,
      iconWidth: {
        desktop: 40,
        mobile: 30,
      },
      iconHeight: {
        desktop: 40,
        mobile: 30,
      },
    },
    {
      title: this.$t('credibility.title2'),
      content: this.$t('credibility.content2'),
      icon: IconTimer,
      iconWidth: {
        desktop: 52,
        mobile: 36,
      },
      iconHeight: {
        desktop: 52,
        mobile: 36,
      },
    },
    {
      title: this.$t('credibility.title3'),
      content: this.$t('credibility.content3'),
      icon: IconLock,
      iconWidth: {
        desktop: 38,
        mobile: 29,
      },
      iconHeight: {
        desktop: 38,
        mobile: 30,
      },
    },
    {
      title: this.$t('credibility.title4'),
      content: this.$t('credibility.content4'),
      icon: IconHeadphones,
      iconWidth: {
        desktop: 52,
        mobile: 36,
      },
      iconHeight: {
        desktop: 38,
        mobile: 26,
      },
    },
    ]
  }

  onOfferTypeChange (offerType: OfferTypeKey) {
    this.selectedOfferType = offerType
  }
}
